import { Injectable } from '@angular/core';
import { GenericService } from '../../generic.service';
import { defaultLanguage } from '../../shared/constants/language.constants';
import { LandingService } from '../../landing-page/service/landing.service';
import { TroubleShootingStep } from '../interface/troubleshoot-eh500s.interface';
import { CrowdinService } from '../../shared/service/crowdin.service';

@Injectable({
  providedIn: 'root',
})
export class ResultIssuesEh500sService {
  stepsList: TroubleShootingStep[] = [];
  issueName: string | undefined = '';
  currentLanguageName: string = defaultLanguage;

  constructor(
    private genericService: GenericService,
    private landingService: LandingService,
    private crowdinService: CrowdinService,
  ) {
    this.landingService.languageName$.subscribe((langName) => {
      this.currentLanguageName = langName || defaultLanguage;
    });
  }

  getResultIssuesEh500sIssues(): any[] {
    const issues: any[] = [];
    this.stepsList = [];

    for (const option of this.resultIssues.options) {
      const label = this.crowdinService.getTranslation(option.labelKey!);

      if (option.steps?.length) {
        issues.push({ key: option.steps[0].key, label });
        this.stepsList.push(...option.steps);
      } else {
        issues.push({ key: option.key, label });
      }
    }

    return issues;
  }

  setIssuename(issuename: string | undefined) {
    this.issueName = issuename;
  }

  getIssuename() {
    return this.issueName;
  }

  getTroubleShootStep(searchKey: string): TroubleShootingStep | null {
    return this.genericService.findObjectByKey(
      searchKey,
      this.resultIssues.options,
    );
  }

  getStepState() {
    return this.stepsList;
  }

  getStepIndex(key: string) {
    return this.stepsList.findIndex((step) => step.key === key);
  }

  resultIssues: TroubleShootingStep = {
    key: 'resultIssues',
    options: [
      {
        key: 'resultIssues-itemClean',
        labelKey: 'troubleshooting.resultIssues.itemClean.label',
        option: 'troubleshooting.resultIssues.itemClean',
        steps: [
          {
            key: 'resultIssues-itemCleanlist-items',
            options: [],
            machineIssueListItems: [
              {
                keyValue: 1,
                titleKey: 'troubleshooting.resultIssues.detergent.title',
                detailKeys: ['troubleshooting.resultIssues.detergent.details'],
                answered: false,
              },
              {
                keyValue: 2,
                titleKey: 'troubleshooting.resultIssues.sprayArm.title',
                detailKeys: [
                  'troubleshooting.resultIssues.sprayArm.detail1',
                  'troubleshooting.resultIssues.sprayArm.detail2',
                ],
                answered: false,
              },
              {
                keyValue: 3,
                titleKey: 'troubleshooting.resultIssues.sprayBlock.title',
                detailKeys: ['troubleshooting.resultIssues.sprayBlock.details'],
                answered: false,
              },
              {
                keyValue: 4,
                titleKey: 'troubleshooting.resultIssues.soilFilter.title',
                detailKeys: ['troubleshooting.resultIssues.soilFilter.details'],
                answered: false,
              },
              {
                keyValue: 5,
                titleKey: 'troubleshooting.resultIssues.dishWash.title',
                detailKeys: ['troubleshooting.resultIssues.dishWash.details'],
                answered: false,
              },
              {
                keyValue: 6,
                titleKey: 'troubleshooting.resultIssues.dirt.title',
                detailKeys: [
                  'troubleshooting.resultIssues.dirt.detail1',
                  'troubleshooting.resultIssues.dirt.detail2',
                ],
                answered: false,
              },
              {
                keyValue: 7,
                titleKey: 'troubleshooting.resultIssues.washTemp.title',
                detailKeys: ['troubleshooting.resultIssues.washTemp.details'],
                answered: false,
              },
            ],
          },
        ],
      },
      {
        key: 'resultIssues-visibleStain',
        labelKey: 'troubleshooting.resultIssues.visibleStain.label',
        option: 'troubleshooting.resultIssues.visibleStain',
        steps: [
          {
            key: 'resultIssues-visibleStainlist-items',
            options: [],
            machineIssueListItems: [
              {
                keyValue: 8,
                titleKey: 'troubleshooting.resultIssues.hardness.title',
                detailKeys: [
                  'troubleshooting.resultIssues.hardness.detail1',
                  'troubleshooting.resultIssues.hardness.detail2',
                ],
                answered: false,
              },
              {
                keyValue: 9,
                titleKey: 'troubleshooting.resultIssues.starch.title',
                detailKeys: ['troubleshooting.resultIssues.starch.details'],
                answered: false,
              },
            ],
          },
        ],
      },
      {
        key: 'resultIssues-plateCup',
        labelKey: 'troubleshooting.resultIssues.plateCup.label',
        option: 'troubleshooting.resultIssues.plateCup',
        steps: [
          {
            key: 'resultIssues-plateCuplist-items',
            options: [],
            machineIssueListItems: [
              {
                keyValue: 10,
                titleKey: 'troubleshooting.resultIssues.rinse.title',
                detailKeys: ['troubleshooting.resultIssues.rinse.detail'],
                answered: false,
              },
              {
                keyValue: 11,
                titleKey: 'troubleshooting.resultIssues.washCycle.title',
                detailKeys: ['troubleshooting.resultIssues.washCycle.detail'],
                answered: false,
              },
              {
                keyValue: 12,
                titleKey: 'troubleshooting.resultIssues.washTemperature.title',
                detailKeys: [
                  'troubleshooting.resultIssues.washTemperature.detail',
                ],
                answered: false,
              },
            ],
          },
        ],
      },
      {
        key: 'resultIssues-glasses',
        labelKey: 'troubleshooting.resultIssues.glasses.label',
        option: 'troubleshooting.resultIssues.glasses',
        steps: [
          {
            key: 'resultIssues-glassesList-items',
            options: [],
            machineIssueListItems: [
              {
                keyValue: 13,
                titleKey: 'troubleshooting.resultIssues.glassCorrosion.title',
                detailKeys: [
                  'troubleshooting.resultIssues.glassCorrosion.detail',
                ],
                answered: false,
              },
            ],
          },
        ],
      },
    ],
  };
}
